import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { default as Scheme$64d2 } from '/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/plugins/apollo-scheme.js'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/auth/inloggen",
    "logout": "/auth/inloggen",
    "home": "/",
    "callback": "/login"
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth",
    "options": {
      "path": "/"
    }
  },
  "localStorage": false,
  "defaultStrategy": "apollo"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // apollo
  $auth.registerStrategy('apollo', new Scheme$64d2($auth, {
  "name": "apollo",
  "token_type": "Bearer",
  "default": true
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
